import { NavLink } from "react-router-dom";
import { Drawer } from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

import Logo from "../../assests/logo/hipship.png";
import SideMenu from "./SideMenu";

interface Props {
  open: boolean;
  onClose: () => void;
  onSearch: () => void;
}

// Phone/tablet sidebar: opens from the menu button in the top bar, closes after a page is chosen.
const MobileSidebar = ({ open, onClose, onSearch }: Props) => (
  <Drawer anchor="left" open={open} onClose={onClose} PaperProps={{ sx: { width: "min(300px, 86vw)", border: "none" } }}>
    <div className="sb-shell sb-shell--mobile">
      <div className="sb-head">
        <NavLink to="/" className="sb-brand no-hover" onClick={onClose} aria-label="Hipship home">
          <img draggable={false} src={Logo} alt="Hipship" />
        </NavLink>
        <button type="button" className="sb-close" onClick={onClose} aria-label="Close menu">
          <CloseRoundedIcon />
        </button>
      </div>
      <div className="sb-scroll">
        <SideMenu
          onNavigate={onClose}
          onSearch={() => {
            onClose();
            onSearch();
          }}
        />
      </div>
    </div>
  </Drawer>
);

export default MobileSidebar;
